var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.295,
    height: 18.655,
    viewBox: "0 0 20.295 18.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-filter",
    "data-name": "Icon feather-filter",
    d: "M2.946,4.446,9.507,12.2v5.364l3.281,1.64v-7l6.561-7.759H2.946m0-1.946h16.4a1.946,1.946,0,0,1,1.486,3.2l-6.1,7.215v6.292a1.946,1.946,0,0,1-2.816,1.74l-3.281-1.64a1.946,1.946,0,0,1-1.076-1.74V12.917L1.46,5.7A1.946,1.946,0,0,1,2.946,2.5Z",
    transform: "translate(-1 -2.5)",
    fill: "#323444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.50f9ace13e0952bdea2d1fda59083fc8.svg";
export { ForwardRef as ReactComponent };